import { IPog } from '../ProtoPogPage.types';

export enum PogActionType {
  PRINT = 'print',
  BUILD = 'build',
  PEGX = 'pegx',
  GET_FILE = 'getfile',
  GET_PROTO_POG_FILE = 'getProtoPogFile',
}

export type IButtonGroupProps = {
  label: string;
  clickHandler: (pog: IPog) => void;
  isAvailable: (pog: IPog) => boolean;
  type?: PogActionType;
};

export type IButtonsGroupProps = {
  buttonsConfig: IButtonGroupProps[];
  pog: IPog;
  isButtonInProgress: (buttonId: string) => boolean;
};
